import React from 'react';
import { bool, func } from 'prop-types';

import ConfirmActionModal from './ConfirmActionModal';

const ConfirmBulkEquipmentDeleteModal = ({ 
    open,
    onClose,
    onConfirm, 
    ...props 
}) => {

    return (
        <ConfirmActionModal
            onConfirm={onConfirm}
            onClose={onClose}
            open={open}
            title="Delete Equipment(s)?"
        >   
            Are you sure you want to delete these equipment(s)?
        </ConfirmActionModal>
    );
};

ConfirmBulkEquipmentDeleteModal.defaultProps = {
    open:      false,
    onClose:   () => {},
    onConfirm: () => {},
};

ConfirmBulkEquipmentDeleteModal.propTypes = {
    onClose:   func,
    open:      bool,
    onConfirm: func,
};

export default ConfirmBulkEquipmentDeleteModal;
